/* eslint-disable  */
import * as Sentry from '@sentry/react';

export const captureException = (error: unknown, type = 'error', extra: Record<string, any> = {}) => {
  Sentry.captureException(error, { tags: { type }, extra });
  console.error(error);
};
